import { render, staticRenderFns } from "./HistoryController.vue?vue&type=template&id=6be4dd9b&"
import script from "./HistoryController.vue?vue&type=script&lang=js&"
export * from "./HistoryController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports